<template>
    <div v-if="modalStatus" class="o-modal">
        <div class="o-modal__box">
            <button
                v-if="closable"
                class="o-modal__close"
                @click="$store.dispatch('modalHide', name)"
            >
                <a-icon icon="CloseDark" />
            </button>
            <slot></slot>
            <hr v-if="$slots.actions" class="a-hr o-modal__hr" />
            <div class="o-modal__actions">
                <slot name="actions"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        name: {
            type: String,
            required: true
        },
        closable: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        modalStatus() {
            return this.$store.getters.modalStatus(this.name)
        }
    }
}
</script>
